export default __webpack_public_path__ + "static/media/market_place_1.42d1aa7b.webp";